import { Button, Form, Input, Select, message, Avatar } from 'antd';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Dispatch } from 'redux';
import I18N from 'src/services/I18NService';
import { IStateCollection } from 'src/entity/StateEntity';
import { IMallPharmacyDetail, IMallCategory, IMallBrand, IMallPricePolicy } from '../../../entity/MallEntity';
import { FormComponentProps, FormItemProps } from 'antd/lib/form';
import { MedicineType } from 'src/services/MedicineService';
import { ConfigOrderType } from 'src/constants/Order';
import { reloadMallPharmacy, fetchPricePolicyByPharmacyUUID, fetchPharmacyByUUID, changePharmacy } from 'src/redux/actions/mallPharmacyCreator';
import PriceModelComponent from 'src/components/views/Mall/PriceModelComponent';
import * as moment from 'moment';

interface IPharmacyDetailProps extends RouteComponentProps, FormComponentProps {
  categoryList: IMallCategory[];
  brandList: IMallBrand[];
  dispatch: Dispatch<IStateCollection>;
}

interface IPharmacyDetailState {
  loading: boolean;
  pharmacyInfo: IMallPharmacyDetail | undefined;
  priceModelList: IMallPricePolicy[];
}

class PharmacyDetailForm extends React.Component<IPharmacyDetailProps, IPharmacyDetailState> {
  constructor(props: IPharmacyDetailProps) {
    super(props);

    this.state = {
      loading: false,
      pharmacyInfo: undefined,
      priceModelList: [],
    } as IPharmacyDetailState;
  }

  async componentDidMount() {
    await this.getPharmacyInfo();
    await this.getPriceModelList();
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  /**
   * 获取药库详情
   *
   * @memberof PharmacyDetailForm
   */
  getPharmacyInfo = async () => {
    if (this.state.loading) {
      return;
    }
    try {
      this.setState({
        loading: true,
      });
      const params = this.props.match.params as { uuid: string };
      const res = await fetchPharmacyByUUID(params.uuid);
      if (!!res) {
        this.setState({
          pharmacyInfo: res,
        });
      }
    } catch (error) {
      if (!!error.response) {
        message.error(JSON.stringify(error.response.data));
      } else {
        message.error(I18N.get('err_search_failure'));
      }
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  /**
   * 获取药库的价格模式
   *
   * @memberof PharmacyDetailForm
   */
  getPriceModelList = async () => {
    const { pharmacyInfo } = this.state;
    if (!!pharmacyInfo && !!pharmacyInfo.uuid) {
      if (this.state.loading) {
        return;
      }
      try {
        this.setState({
          loading: true,
        });
        const priceModelList = await fetchPricePolicyByPharmacyUUID(pharmacyInfo.uuid);
        this.setState({
          priceModelList,
        });
      } catch (error) {
        if (!!error.response) {
          message.error(JSON.stringify(error.response.data));
        } else {
          message.error(I18N.get('err_search_failure'));
        }
      } finally {
        this.setState({
          loading: false,
        });
      }
    }
  };

  goback = () => {
    this.props.history.goBack();
  };

  updateName = (e: React.SyntheticEvent) => {
    e.preventDefault();
    this.handleSubmit('name');
  };

  /**
   * @deprecated
   */
  updateOrderType = (e: React.SyntheticEvent) => {
    e.preventDefault();
    this.handleSubmit('order_type');
  };

  handleSubmit = (key: 'name' | 'order_type') => {
    this.props.form.validateFields(async (err, values: Partial<IMallPharmacyDetail>) => {
      if (!err) {
        if (this.state.loading) {
          return;
        }
        try {
          this.setState({
            loading: true,
          });
          const { pharmacyInfo } = this.state;
          if (!!pharmacyInfo && !!pharmacyInfo.uuid) {
            // const data: IMallPharmacyDetail = Object.assign(pharmacyInfo, {
            //   name: values.name,
            //   order_type: values.order_type,
            // });
            let data: Partial<IMallPharmacyDetail> | undefined;
            if (key === 'name') {
              data = {
                uuid: pharmacyInfo.uuid,
                name: values.name,
              };
            } else if (key === 'order_type') {
              data = {
                uuid: pharmacyInfo.uuid,
                order_type: values.order_type,
              };
            }
            if (!!data && !!data.uuid) {
              const res = await changePharmacy(data);
              if (!!res && !!res.uuid) {
                message.success(I18N.get('common_save_success'));
                this.props.dispatch(reloadMallPharmacy());
              }
            }
          }
        } catch (error) {
          if (!!error.response) {
            message.error(JSON.stringify(error.response.data));
          } else {
            message.error(I18N.get('err_save_failure'));
          }
        } finally {
          this.setState({
            loading: false,
          });
        }
      }
    });
  };

  priceModelElement = (): JSX.Element[] => {
    const result: JSX.Element[] = [];
    for (const item of this.state.priceModelList) {
      result.push(<PriceModelComponent key={item.uuid} info={item} />);
    }
    return result;
  };

  render() {
    const { pharmacyInfo } = this.state;
    const { categoryList, brandList } = this.props;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout: FormItemProps = {
      labelCol: { span: 9 },
      wrapperCol: { span: 6 },
    };
    return (
      <div>
        <div className="mall_top_title">
          <span className="mall_title_desc">&nbsp;</span>
          <div className="mall_title_right_button">
            <Button type="primary" onClick={this.goback}>
              {I18N.get('common_back')}
            </Button>
          </div>
        </div>

        {!!pharmacyInfo && (
          <div className="mall-pharmacy-info">
            <div className="info-avatar">
              <Avatar style={{ backgroundColor: '#EBC88A', verticalAlign: 'middle' }} size={64}>
                {pharmacyInfo.name.substring(0, 1)}
              </Avatar>
            </div>

            <div className="info-desc">
              <div className="desc-name">{pharmacyInfo.name}</div>
              <div className="desc-create-info">
                <span>
                  {I18N.get('common_create_user')}: {pharmacyInfo.created_by}
                </span>
                <span>
                  {I18N.get('common_create_date_time')}: {moment(pharmacyInfo.created_time).format('YYYY-MM-DD HH:mm:ss')}
                </span>
              </div>
            </div>
          </div>
        )}

        <Form>
          <div className="pharmacy-detail-form-item">
            <Form.Item label={I18N.get('common_name_desc')} {...formItemLayout}>
              {getFieldDecorator(`name`, {
                rules: [
                  {
                    required: true,
                    message: `${I18N.get('common_input')}${I18N.get('common_name_desc')}`,
                  },
                ],
                initialValue: !!pharmacyInfo ? pharmacyInfo.name : null,
              })(<Input maxLength={15} minLength={1} placeholder={`${I18N.get('common_input')}${I18N.get('common_name_desc')}`} />)}
            </Form.Item>
            <a className="pharmacy-detail-form-item-a" onClick={this.updateName}>
              &nbsp;&nbsp;{I18N.get('common_save')}&nbsp;&nbsp;
            </a>
          </div>
          <Form.Item label={I18N.get('pharmacy_category')} {...formItemLayout}>
            {getFieldDecorator(`category`, {
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_choose')}${I18N.get('pharmacy_category')}`,
                },
              ],
              initialValue: !!pharmacyInfo ? pharmacyInfo.category : null,
            })(
              <Select disabled={true} placeholder={`${I18N.get('common_choose')}${I18N.get('pharmacy_category')}`}>
                {categoryList.map(f => {
                  return (
                    <Select.Option key={`${f.uuid}`} value={f.code}>
                      {f.name}
                    </Select.Option>
                  );
                })}
              </Select>
            )}
          </Form.Item>
          <Form.Item label={I18N.get('pharmacy_brand')} {...formItemLayout}>
            {getFieldDecorator(`brand`, {
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_choose')}${I18N.get('pharmacy_brand')}`,
                },
              ],
              initialValue: !!pharmacyInfo ? pharmacyInfo.brand : null,
            })(
              <Select disabled={true} placeholder={`${I18N.get('common_choose')}${I18N.get('pharmacy_brand')}`}>
                {brandList.map(f => {
                  return (
                    <Select.Option key={`${f.uuid}`} value={f.uuid}>
                      {f.name}
                    </Select.Option>
                  );
                })}
              </Select>
            )}
          </Form.Item>
          <Form.Item label={I18N.get('pharmacy_dosage_form')} {...formItemLayout}>
            {getFieldDecorator(`dosage_form`, {
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_choose')}${I18N.get('pharmacy_dosage_form')}`,
                },
              ],
              initialValue: !!pharmacyInfo ? pharmacyInfo.dosage_form : null,
            })(
              <Select disabled={true} placeholder={`${I18N.get('common_choose')}${I18N.get('pharmacy_dosage_form')}`}>
                {MedicineType.map(m => {
                  return (
                    <Select.Option key={m.key} value={m.value}>
                      {I18N.get(m.key)}
                    </Select.Option>
                  );
                })}
              </Select>
            )}
          </Form.Item>
          <div className="pharmacy-detail-form-item">
            <Form.Item label={I18N.get('order_category')} {...formItemLayout}>
              {getFieldDecorator(`order_type`, {
                rules: [
                  {
                    required: true,
                    message: `${I18N.get('common_choose')}${I18N.get('order_category')}`,
                  },
                ],
                initialValue: !!pharmacyInfo ? pharmacyInfo.order_type : null,
              })(
                <Select disabled={true} placeholder={`${I18N.get('common_choose')}${I18N.get('order_category')}`}>
                  {ConfigOrderType.map(m => {
                    return (
                      <Select.Option key={m.key} value={m.value}>
                        {I18N.get(m.key)}
                      </Select.Option>
                    );
                  })}
                </Select>
              )}
            </Form.Item>
            {/* <a className="pharmacy-detail-form-item-a" onClick={this.updateOrderType}>
              &nbsp;&nbsp;{I18N.get('common_save')}&nbsp;&nbsp;
            </a> */}
          </div>
          {this.state.priceModelList.length > 0 && (
            <Form.Item label={I18N.get('med_price_area')} {...formItemLayout}>
              <div className="pharmacy-price-model">{this.priceModelElement()}</div>
            </Form.Item>
          )}
        </Form>
      </div>
    );
  }
}

const PharmacyDetailComponent = Form.create<IPharmacyDetailProps>()(PharmacyDetailForm);
export default PharmacyDetailComponent;



// WEBPACK FOOTER //
// ./src/components/views/Mall/PharmacyDetail.tsx